import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useTranslation } from "react-i18next";
import { useProducts } from "@redux/slices/globalSlice";

const useAllowedProductTypes = () => {
  const userInfo = useUserInfo();
  const { t } = useTranslation();
  const products = useProducts();
  const allowedProducts = products
    .filter((product: any) =>
      userInfo?.getAllowedStockTypes()?.includes(product.key)
    )
    .sort(
      (itemFirst: any, itemSecond: any) => itemFirst.order - itemSecond.order
    );

  return allowedProducts.map((section: any) => {
    return {
      ...section,
      label: t(section.label),
    };
  });
};

export default useAllowedProductTypes;
